import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import get from 'lodash/get';

import Seller from 'models/seller';

import { AppConsumer } from 'providers/app-provider';

const propTypes = {
  mounted: PropTypes.bool,
  seller: PropTypes.instanceOf(Seller),
};

const defaultProps = {
  seller: null,
  mounted: false,
};

export const Tooltip = ({ mounted, seller }) => {
  if (!mounted) { return null; }

  return (
    <ReactTooltip
      id="eventTooltip"
      globalEventOff="click"
      place="bottom"
      type="dark"
      effect="solid"
      offset={{ top: 0, left: 0 }}
    >
      Pricing and availability for event parking are set by {get(seller, 'name', '')}, the facility operator.
      Changing reservation times may affect your ability to book this space or lock in this price.
    </ReactTooltip>
  );
};

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

const TooltipWrapper = props => (
  <AppConsumer><Tooltip {...props} /></AppConsumer>
);

export default TooltipWrapper;
